var Theme = Theme || {};

Theme.stickySplitviewNav = (function ($) {

    //Sticky navigation tools on splitview if turned on in client design settings ($split-view-hidden-header).
    function stickySplitviewNav() {
        if ($('.pg_articlesplitview').length) {
            var scroll = $(this).scrollTop();
            if (scroll > $('.splitview__wrapper').offset().top - 10) {
                $('.pg_articlesplitview').addClass('stuck js-stuck');
                //Once header is out of viewport allow independent scrolling in each panel.
                $('.pg_articlesplitview').removeClass('sticky-splitview-nav js-sticky-splitview-nav');         
            } else {
                $('.pg_articlesplitview').removeClass('stuck js-stuck');
                //Add the class once again when header is in view.
                $('.pg_articlesplitview').addClass('sticky-splitview-nav js-sticky-splitview-nav');
            }
            SCM.SiteJS.scrollToTarget();
        }
    }

    function handleDoubleScrollBars($scrolledElement) {
        if ($scrolledElement.scrollTop() > 0) {
            $('.pg_articlesplitview').addClass('scroll-hidden');
        } else {
            $('.pg_articlesplitview').removeClass('scroll-hidden')
        }
    }

    // On document.ready, add class if we are in splitview to prevent independent scrolling within panes
    $('.pg_articlesplitview').addClass('sticky-splitview-nav js-sticky-splitview-nav');

    $(window).on('resize', function () {
        stickySplitviewNav();
    });

    $(window).on('scroll', function () {
        stickySplitviewNav();
    });

    $('.js-content-splitview').on('scroll', function () {
        handleDoubleScrollBars($(this));
    });

    $('.js-panel-wrapper').on('scroll', function () {
        handleDoubleScrollBars($(this));
    });

})(jQuery);
